import React, {useState, useEffect} from 'react'
import classes from './ResultItem.module.css'
import {MDBBadge} from "mdbreact";
import {getCategoryDisplayName, getSubCategoryDisplayName} from "../../../Utils/category";
import {Trans} from "react-i18next";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faChevronDown,
    faSortDown,
    faSortUp,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import {SUPPORTED_FUNCTIONS} from "../../../Utils/FunctionList";
import ShareContainer from "../../../Component/ShareContainer/ShareContainer";
import ProgImg from "react-prog-img";
import {getAPIPath} from "../../../Utils/HelpingFunction";
import AdSense from "react-adsense";

const ResultItem = (props) => {

    const [isVoted, setIsVoted] = useState(false)
    const [voteResult, setVoteResult] = useState(false)
    const [dropDownOpen, setDropDownOpen] = useState(false)

    useEffect(() => {
        if (!props.isAd) {
            setIsVoted(localStorage.getItem('m-item-' + (props.data.hasOwnProperty('id') ? props.data.id : props.data.objectID)) !== null)
            setVoteResult(localStorage.getItem('m-item-' + (props.data.hasOwnProperty('id') ? props.data.id : props.data.objectID)))
        }
    }, [])

    const vote = async (itemID, isUpVote) => {
        return await new Promise((resolve, reject) => {
            fetch(getAPIPath("/api/data/vote"), {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    dataID: itemID,
                    isUpVote: isUpVote
                })
            }).then((res) => res.json()).then((searchResult) => {
                if (searchResult.success) {
                    setIsVoted(true)
                    localStorage.setItem('m-item-' + itemID, isUpVote.toString())
                    setVoteResult(isUpVote ? "true" : "false")
                }
            })
        })
    }


    if (props.isAd) {
        return (
            <div className={classes.ResultItem}>
                <div className={classes.Top}>
                    <div>
                        <div className={classes.VoteBtnContainer}>
                            <button
                                className={classes.VoteBtn}
                                disabled={true}
                            >
                                <FontAwesomeIcon icon={faSortUp}/>
                            </button>
                            <button
                                className={classes.VoteBtn}
                                disabled={true}
                            >
                                <FontAwesomeIcon icon={faSortDown}/>
                            </button>
                        </div>
                    </div>
                    <div>
                        <div className={classes.BadgeContainer}>

                            <MDBBadge color={'info'}>
                                Google Ad
                            </MDBBadge>


                            <span color={''} className={classes.SubCateBadge}>

                        </span>

                            <div className={classes.DropdownContainer}>
                                <label className={classes.checkbox}>
                                    <input type="checkbox" value="valueofcheckbox" checked="checked"/>
                                    <FontAwesomeIcon icon={faChevronDown} className={classes.Icon}/>
                                </label>
                                {
                                    dropDownOpen &&
                                    <ul className={classes.submenu}>
                                        <li>
                                            <Trans>ResultItem.report</Trans>
                                        </li>
                                    </ul>
                                }

                            </div>
                        </div>

                    </div>

                </div>
                <div style={{marginTop: "-43px"}}>
                    <AdSense.Google
                        client='ca-pub-1148458867150362'
                        slot='8279990672'
                        style={{display: 'block'}}
                        format='fluid'
                        responsive='true'
                        layoutKey='-f8+56-n-ib+zy'
                    />
                </div>

                <div>
                    <ShareContainer
                        url={"https://mewesearcher.com/"}
                        img={"https://mewesearcher.web.app/logo512.png"}
                        title={"MeWeSearcher"}
                        content={""}
                        tags={[]}
                    />
                </div>

            </div>
        )
    } else {
        return (
            <div className={classes.ResultItem}>
                <div className={classes.Top}>
                    <div>
                        <div className={classes.VoteBtnContainer}>
                            <button
                                className={isVoted ? voteResult === "true" ? classes.UpVotedBtn : classes.VoteBtn : classes.VoteBtn}
                                disabled={isVoted}
                                onClick={() => {
                                    let id = props.data.hasOwnProperty('id') ? props.data.id : props.data.objectID
                                    vote(id, true)
                                }}
                            >
                                <FontAwesomeIcon icon={faSortUp}/>
                            </button>
                            <button
                                className={isVoted ? voteResult === "false" ? classes.DownVotedBtn : classes.VoteBtn : classes.VoteBtn}
                                disabled={isVoted}
                                onClick={() => {
                                    let id = props.data.hasOwnProperty('id') ? props.data.id : props.data.objectID
                                    vote(id, false)
                                }}
                            >
                                <FontAwesomeIcon icon={faSortDown}/>
                            </button>
                        </div>
                    </div>
                    <div className={classes.TopRightContainer}>
                        <div className={classes.BadgeContainer}>
                            <Link to={"/c/" + props.data.category}>
                                <MDBBadge color={'info'}>
                                    {getCategoryDisplayName(props.data.category)}
                                </MDBBadge>
                            </Link>

                            <Link to={"/c/" + props.data.category + "?subCID=" + props.data.subCategory}>
                        <span color={''} className={classes.SubCateBadge}>
                            {getSubCategoryDisplayName(props.data.category, props.data.subCategory)}
                        </span>
                            </Link>
                            <div className={classes.DropdownContainer}>
                                <label className={classes.checkbox}>
                                    <input type="checkbox" value="valueofcheckbox" checked="checked"
                                           onClick={() => setDropDownOpen(!dropDownOpen)}/>
                                    <FontAwesomeIcon icon={faChevronDown} className={classes.Icon}/>
                                </label>
                                {
                                    dropDownOpen &&
                                    <ul className={classes.submenu}>
                                        <li onClick={() => {
                                            props.setModalController({
                                                type: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                                typeOfModal: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                                isModalOpen: true,
                                                metadata: {itemID: props.data.hasOwnProperty('id') ? props.data.id : props.data.objectID}
                                            })
                                        }}>
                                            <Trans>ResultItem.report</Trans>
                                        </li>
                                    </ul>
                                }

                            </div>
                        </div>
                        <div className={classes.Title}>
                            {props.data.title}
                        </div>
                    </div>

                </div>

                <div className={classes.DetailContainer}>
                    <div className={classes.ImageContainer}>

                        <ProgImg effect="blur"
                                 bg={'#eee'}
                                 src={props.data.hasOwnProperty('imageSrc') ? props.data.imageSrc : "#"}
                                 alt={props.data.title}
                                 conf={{isLazy: false}}
                                 className={["darkmode-ignore", classes.CategoryImg].join(" ")}
                        />

                        <div className={classes.NumberOfMember}>
                            <FontAwesomeIcon icon={faUsers}/>
                            {props.data.hasOwnProperty('numberOfMember') ? props.data.numberOfMember : "未處理"}
                        </div>

                    </div>
                    <div className={classes.Description}>
                        {props.data.description}
                    </div>
                </div>

                <div>
                    <ShareContainer
                        url={"https://mewesearcher.com/search?objectID=" + props.data.title.split(" ").join("")}
                        img={"https://mewesearcher.web.app/logo512.png"}
                        title={"我要分享呢個MeWe" + props.data.title + "比你"}
                        content={props.data.description}
                        tags={[]}
                    />
                </div>


                {
                    props.type === "admin" ?
                        <button className={classes.SubBtn}
                                onClick={() => props.updateExistValue(props.data.hasOwnProperty('id') ? props.data.id : props.data.objectID)}>
                            <Trans>ResultItem.update-value</Trans>
                        </button>
                        :
                        <div>
                            <a href={props.data.url} target={"_blank"} rel="noreferrer">
                                <button className={classes.SubBtn}>
                                    <Trans>ResultItem.go</Trans> {props.data.type === 'page' ?
                                    <Trans>ResultItem.page</Trans> :
                                    <Trans>ResultItem.group</Trans>}
                                </button>
                            </a>

                        </div>
                }
            </div>
        )
    }


}

export default ResultItem